// ─────────────────────────────────────────────────────────────────
// Djuplänkar från mejl och push, t.ex. /?tab=garderob&sub=att_skicka&tx=<id>
// (api/src/lib/email.ts, garderobPath). App.tsx läser dem vid start och rensar
// adressen. Är man inte inloggad sparas länken i sessionStorage. Den överlever
// då inloggningen, även när Qid skickar tillbaka till /auth/callback utan
// parametrar, och används när inloggningen är klar.
// ─────────────────────────────────────────────────────────────────

export interface DeepLink {
  tab: string;
  sub?: string;
  /** Transaktion (affär) som ska markeras i Min garderob. */
  tx?: string;
  /** Konversation i Meddelanden. */
  c?: string;
}

const KEY = 'qvestium_deep_link';
const ID = /^[A-Za-z0-9_-]{1,100}$/;
const SUB = /^[\p{L}_]{1,40}$/u;

/** Läser tab/sub/tx/c ur en query-sträng. Okända eller konstiga värden ignoreras. */
export function parseDeepLink(search: string): DeepLink | null {
  const p = new URLSearchParams(search);
  const tab = p.get('tab');
  if (!tab || !/^[a-z_]{1,30}$/.test(tab)) return null;
  const link: DeepLink = { tab };
  const sub = p.get('sub');
  if (sub && SUB.test(sub)) link.sub = sub;
  const tx = p.get('tx');
  if (tx && ID.test(tx)) link.tx = tx;
  const c = p.get('c');
  if (c && ID.test(c)) link.c = c;
  return link;
}

export function saveDeepLink(link: DeepLink): void {
  try { sessionStorage.setItem(KEY, JSON.stringify(link)); } catch { /* privat läge */ }
}

export function clearDeepLink(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* ignorera */ }
}

/** Den sparade länken, som tas bort samtidigt (används en gång). */
export function takeDeepLink(): DeepLink | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && typeof v.tab === 'string' ? parseDeepLink(new URLSearchParams(Object.entries(v).filter(([, x]) => typeof x === 'string') as [string, string][]).toString()) : null;
  } catch { return null; }
}

/** Finns det en sparad länk som väntar på inloggning? */
export function hasDeepLink(): boolean {
  try { return sessionStorage.getItem(KEY) != null; } catch { return false; }
}
